<script>
  import Label from './form-label.svelte'
  import { cn } from '@lib/utils'
  
  let { label, children, class: className, optionsClass, optionsSection = false, optionsDirection = "row" } = $props()

  let optionsBaseClass = $derived("flex items-center flex-wrap col-span-12 gap-6 mt-3")
  let optionsDirectionClass = $derived(optionsDirection === "row" ? "flex-row" : "flex-col items-start gap-3 mt-2")
  let optionsContainerClass = $derived(cn(optionsBaseClass, optionsDirectionClass, optionsClass))
</script>

<fieldset class={cn("col-span-12 gap-y-2", className)}>

  {#if label}
    <Label {label} class="pb-4" />
  {/if}

  {#if optionsSection}
    <div class={optionsContainerClass}>
      {@render children?.()}
    </div>
  {:else}
    {@render children?.()}
  {/if}
  
</fieldset>